import './About.css';
import Placeholder from './Placeholder';
import Icon from './Icon';
import useReveal from './useReveal';

const TIMELINE = [
  'Kingfisher Airlines: Cabin Crew · Communication & Service Excellence',
  'Corporate leadership: Sales Executive to Vice President, Sales & Marketing (13 yrs)',
  'WAYFWD Strategies: Founder & Lead Trainer',
];

const CHIPS = [
  'Communication',
  'Leadership',
  'Workplace readiness',
  'Soft skills',
  'Executive presence',
  'POSH & POCSO',
];

export default function About() {
  const textRef = useReveal({ stagger: 90, maxStaggered: 5 });
  const timelineRef = useReveal({ stagger: 120, maxStaggered: 3 });
  const mediaRef = useReveal();

  return (
    <section id="about" className="about">
      <div className="container about__inner">
        <div className="about__media reveal--scale" ref={mediaRef}>
          <div className="about__frame">
            <span className="about__aura" aria-hidden="true" />
            <Placeholder
              id="about-portrait"
              src="/assets/img/anjum-about.webp"
              alt="Anjum Qazi working on a laptop"
              objectPosition="50% 50%"
              label="Anjum portrait (secondary image)"
              aspect="1 / 1"
              frame="offset"
              className="about__portrait"
            />
            {/* Border that traces around the card on hover. */}
            <svg className="about__trace" viewBox="0 0 100 100" preserveAspectRatio="none" aria-hidden="true">
              <rect x="1.5" y="1.5" width="97" height="97" rx="3" pathLength="100" vectorEffect="non-scaling-stroke" />
            </svg>
            <span className="about__badge">
              <span className="about__badge-icon" aria-hidden="true">
                <Icon name="award-ribbon" size={18} strokeWidth={1.8} />
              </span>
              <span className="about__badge-body">
                <strong>Founder</strong>
                <em>&amp; Lead Trainer</em>
              </span>
            </span>
          </div>
        </div>

        <div className="about__text" ref={textRef}>
          <h2 className="about__title">About Anjum Qazi</h2>
          <p className="about__bio">
            From Cabin Crew at Kingfisher Airlines to Vice President, Sales &amp; Marketing in a manufacturing company: a 13-year corporate leadership journey and 17+ years of industry experience, turned into practical training that delivers real outcomes for organisations.
          </p>

          <p className="eyebrow about__label">CAREER TIMELINE</p>
          <ol className="about__timeline" ref={timelineRef}>
            {TIMELINE.map((row, i) => (
              <li className="about__row" key={row}>
                <span className="about__dot" aria-hidden="true" />
                <span className="about__num" aria-hidden="true">
                  {String(i + 1).padStart(2, '0')}
                </span>
                <span className="about__row-text">{row}</span>
              </li>
            ))}
          </ol>

          <ul className="about__chips">
            {CHIPS.map((c) => (
              <li className="about__chip" key={c}>{c}</li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}
